import { USER_ROLE_NON_ADVISORY_USER } from '@savvy/constants/user-roles';

type HomeLandingInput = {
  readonly homeRedesignEnabled: boolean;
  readonly role: string | null | undefined;
};

export function shouldLandOnRedesignedHome({ homeRedesignEnabled, role }: HomeLandingInput): boolean {
  if (!homeRedesignEnabled) {
    return false;
  }
  return role !== USER_ROLE_NON_ADVISORY_USER;
}
